var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1445 0.537009C20.2242 1.18623 19.2051 1.68277 18.1266 2.00753C17.5478 1.34196 16.7785 0.870222 15.9228 0.656117C15.0671 0.442011 14.1664 0.495868 13.3423 0.810403C12.5182 1.12494 11.8106 1.68498 11.3152 2.41477C10.8198 3.14457 10.5604 4.00891 10.5723 4.8909V5.85202C8.88323 5.89582 7.20959 5.52121 5.70038 4.76157C4.19118 4.00193 2.89326 2.88084 1.92223 1.49813C1.92223 1.49813 -1.92223 10.1482 6.72781 13.9927C4.74842 15.3364 2.39044 16.0101 0 15.915C8.65004 20.7206 19.2223 15.915 19.2223 4.86206C19.2214 4.59435 19.1957 4.32729 19.1454 4.06433C20.1263 3.09695 20.8185 1.87558 21.1445 0.537009Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.96009a47dbf8f8dacd982565db3a8275.svg";
export { ForwardRef as ReactComponent };